import React, { useState } from 'react';
import { FaSignInAlt, FaEnvelope, FaLock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from "../services/api";
import { setSession } from "../lib/auth";

const Signin = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/api/auth/login", {
        email,
        password,
      });
      // 🔐 Enregistrer le token + user pour la session
      setSession(res.data.token, res.data.user);

      setMessage(t('auth.signinSuccess') + ' ✔️');

      // Vérifier si l’utilisateur venait de cliquer sur “Créer ma radio”
      const fromCreateRadio = localStorage.getItem('fromCreateRadio');

      // Supprimer l’indicateur
      localStorage.removeItem('fromCreateRadio');

      if (fromCreateRadio === 'true') {
        navigate('/creer-radio/step1');
      } else {
        // Après connexion : espace créateur (Mes radios)
        navigate('/mes-radios');
      }
    } catch (error) {
      setMessage(t('auth.signinError') + ' ❌');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f7ff] to-[#faf8ff] flex flex-col items-center justify-center px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md text-center">
        <div className="text-4xl mx-auto mb-4 text-white bg-gradient-to-br from-purple-500 to-blue-500 rounded-full w-16 h-16 flex items-center justify-center">
          <FaSignInAlt />
        </div>
        <h1 className="text-3xl font-bold text-purple-600 mb-2">{t('auth.signinTitle')}</h1>
        <p className="text-gray-600 mb-6">{t('auth.signinSubtitle')}</p>

        <form onSubmit={handleSubmit} className="space-y-4 text-start">
          <div>
            <label className="text-sm font-medium text-gray-700">{t('auth.email')}</label>
            <div className="flex items-center border rounded-md px-3 py-2 mt-1">
              <FaEnvelope className="text-gray-400 me-2" />
              <input
                type="email"
                required
                className="w-full outline-none bg-transparent"
                placeholder={t('auth.emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700">{t('auth.password')}</label>
            <div className="flex items-center border rounded-md px-3 py-2 mt-1">
              <FaLock className="text-gray-400 me-2" />
              <input
                type="password"
                required
                className="w-full outline-none bg-transparent"
                placeholder={t('auth.passwordPlaceholder')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {message && (
            <div className="text-center text-sm text-red-500 mt-2">{message}</div>
          )}

          <div className="text-end">
            <a href="/forgot-password" className="text-sm text-purple-600 hover:underline">
              {t('auth.forgotPassword')}
            </a>
          </div>

          <button
            type="submit"
            className="w-full py-2 text-white font-semibold rounded-md bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition"
          >
            {t('auth.signinButton')}
          </button>
        </form>

        <p className="text-sm mt-6">
          {t('auth.noAccount')}{' '}
          <a href="/signup" className="text-purple-600 hover:underline">
            {t('auth.signupButton')}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Signin;

